import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { roleBasedLogin, forgotPassword } from '../api';
import { useAuth } from '../AuthContext';
import PopupMessage from './PopupMessage';
import '../App.css';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);

    if (isForgotPassword) {
      try {
        const res = await forgotPassword({ email: formData.email });
        if (res.success) {
          setMessage('Password reset email sent successfully.');
          setShowSuccessPopup(true);
          setTimeout(() => setIsForgotPassword(false), 2000);
        } else {
          setError(res.message || 'Failed to send email.');
          setShowErrorPopup(true);
        }
      } catch (err) {
        setError("Something went wrong. Please try again.");
        setShowErrorPopup(true);
      }
    } else {
      try {
        const result = await roleBasedLogin({
          email: formData.email,
          password: formData.password,
        });

        if (result.success) {
          login(result.data.user, result.data.token);
          setMessage('✅ Login successful! Redirecting...');

          setTimeout(() => {
            navigate('/candidates');
          }, 1500);
        } else {
          setError(result.message || 'Login failed. Please try again.');
          setShowErrorPopup(true);
        }
      } catch (err) {
        setError("An error occurred during login. Please try again.");
        setShowErrorPopup(true);
      }
    }
    setIsLoading(false);
  };

  return (
    <div className="login-wrapper">
      <div className="login-grid">
        <div className="login-container">
          <div className="login-box">
            <h1 className="welcome-heading">Recruiter</h1>
            {isForgotPassword ? (
              <>
                <form onSubmit={handleSubmit}>
                  <div className="login-form">
                    <input
                      type="email"
                      className="login-input"
                      id="email"
                      placeholder="Enter your registered email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                    <button type="submit" className="home-btn" disabled={isLoading}>
                      {isLoading ? 'Sending...' : 'Send Mail'}
                    </button>
                  </div>
                  {message && <p className="success-message">{message}</p>}
                  {error && <p className="login-error">{error}</p>}
                </form>
                <p onClick={() => setIsForgotPassword(false)} className="login-link">Back to Login</p>
              </>
            ) : (
              <>
                <form onSubmit={handleSubmit}>
                  <div className="login-form">
                    <input
                      type="email"
                      className="login-input"
                      id="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                    <input
                      type="password"
                      className="login-input"
                      id="password"
                      placeholder="Password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                    <button type="submit" className="home-btn" disabled={isLoading}>
                      {isLoading ? 'Logging in...' : 'Login'}
                    </button>
                  </div>
                </form>
                <p onClick={() => setIsForgotPassword(true)} className="login-link">Forgot Password?</p>
              </>
            )}
          </div>
        </div>

        <div className="login-container">
          <div className="login-box">
            <h1 className="welcome-heading">Resume</h1>
            <div className="login-form">
              <button
                type="button"
                className="home-btn"
                onClick={() => navigate('/resume')}
              >
                Submit Resume
              </button>
              {/* <button
                type="button"
                className="home-btn"
                onClick={() => navigate('/resume-builder')}
              >
                Resume Builder
              </button> */}
            </div>
          </div>
        </div>
      </div>

      {/* Error Popup */}
      <PopupMessage
        visible={showErrorPopup}
        title="❌ Error"
        message={error}
        type="error"
        onClose={() => setShowErrorPopup(false)}
      />

      {/* Success Popup */}
      <PopupMessage
        visible={showSuccessPopup}
        title="✅ Success"
        message={message}
        type="success"
        onClose={() => setShowSuccessPopup(false)}
      />
    </div>
  );
};

export default Login;
